/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestTagOntology } from '../../models/export-request-tag-ontology';

export interface AddAnalogicOntologyExportRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * Body for new ontology on demand of export
     */
    body: ExportRequestTagOntology
}

export function addAnalogicOntologyExportRequest(http: HttpClient, rootUrl: string, params: AddAnalogicOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTagOntology>> {
  const rb = new RequestBuilder(rootUrl, addAnalogicOntologyExportRequest.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestTagOntology>;
    })
  );
}

addAnalogicOntologyExportRequest.PATH = '/export-request/{uid}/ontology/analogic';
